require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-stadtschlaining.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-stadtschlaining");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-stadtschlaining!./.cache/json/betreuungseinrichtungen-oberwart-stadtschlaining.json
// module id = 1026
// module chunks = 231608221292675